const mobileMaxWidth = 430;
const inihub = location.hostname == 'medp-dev.apwisdom.com' || location.hostname == 'ktdp.apwisdom.com' || location.hostname == 'localhost' ? {
  // type: 'pblc_cwui',// inihub pblc_cwui kftc
  baseUrl: 'https://ktdp.apwisdom.com',
  clientId: ['8285e8ef-8f34-4e68-b77d-552c447bbf02','be47b928-47e2-4d74-a17f-38b10d9949ee'],//개인,법인
} : location.hostname == 'medp-staging.apwisdom.com' || location.hostname == 'medpd' ? {
  baseUrl: 'https://medp-staging.apwisdom.com',
  clientId: ['5bb9fdf2-52ed-4b8f-abeb-4267afd605a2','be47b928-47e2-4d74-a17f-38b10d9949ee'],//개인,법인
} : {
  baseUrl: 'https://medp.mizuhobank.com',
  clientId: ['553ff29b-79f2-41de-b60f-0dfdac34a206','be47b928-47e2-4d74-a17f-38b10d9949ee'],//개인,법인
};

inihub.companyOids = [
// 금융결제원 범용(기업) 은행/보험(기업) 금융인증서(기업)1년~3년 금융인증서(기업)행별3년 금융인증서(기업)전자세금용 전자세금용(기업)
'1.2.410.200005.1.1.5',
'1.2.410.200005.1.1.2',
'1.2.410.200005.1.1.8.11',
'1.2.410.200005.1.1.8.12',
'1.2.410.200005.1.1.8.13',
'1.2.410.200005.1.1.6.10',
'1.2.410.200005.1.1.9.1',
'1.2.410.200005.1.1.8.20',
// 한국무역정보통신 범용(법인)
'1.2.410.200012.1.1.3',
// 코스콤(구)한국증권전산 범용(법인) 증권/보험용(법인) 은행/보험용(법인) 신용카드용(법인)
'1.2.410.200004.5.1.1.7',
'1.2.410.200004.5.1.1.10',
'1.2.410.200004.5.1.1.10.1',
'1.2.410.200004.5.1.1.10.2',
// 한국정보인증 1등급 법인
'1.2.410.200004.5.2.1.1',
// 한국전자인증 범용(법인)
'1.2.410.200004.5.4.1.2',
// 한국전산원 법인
'1.2.410.200004.5.3.1.2',
// INIPASS 범용(기업) 제휴기관용(기업) 전자세금용(기업) 특수목적용(기업)
'1.2.410.200004.5.5.1.2',
'1.2.410.200004.5.5.1.4.1',
'1.2.410.200004.5.5.1.4.2',
'1.2.410.200004.5.5.1.4.5'];

export { inihub, mobileMaxWidth };